import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../../../utils/Custom/Button";
import { submitSiteDelete } from "../../../../utils/commonComponent/delete";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../../utils/Custom/ListSearchSection";
import ListView from "../../../../utils/Custom/listView";
import { getPermissions } from "../../../Pages/rbac/hasAccess";

const headers = [
  "id",
  "requestedId",
  "positionTitle",
  "DateRaised",
  "Client",
  "Discipline",
  "employementType",
  "priority",
  "targetDate",
  "RequestStatus",
  "recruiterAssigned",
];

const fields = [
  { value: "Discipline", label: "Discipline" },
  { value: "requestedId", label: "Requested Id" },
  { value: "Client", label: "Client" },
  { value: "priority", label: "Priority" },
  { value: "recruiterAssigned", label: "Recruiter Assigned" },
];

const RequirementsList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);

  const handleEdit = (row) => navigate(`/talent-acquisition/editRequirements/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("talentAcqRequirement", row.id);

  const [requirementsList, setRequirementsList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Discipline");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const getWhereClause = () => {
    const key = searchKey.trim();
    let whereConditions = ["status = 1"];

    if (searchBy && key) {
      if (searchBy === "recruiterAssigned") {
        whereConditions.push(
          `recruiterAssigned IN (SELECT id FROM employees WHERE name LIKE '%${key}%' OR employeesCode LIKE '%${key}%')`
        );
      } else {
        whereConditions.push(`${searchBy} LIKE '%${key}%'`);
      }
    }

    return `WHERE ${whereConditions.join(" AND ")}`;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    const pagination =
      rowsPerPage !== -1
        ? `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * currentPage}`
        : "";
    return `SELECT * FROM talentAcqRequirement ${whereClause} ORDER BY id DESC ${pagination};`;
  };

  const getCountQuery = () => {
    return `SELECT COUNT(*) AS totalRows FROM talentAcqRequirement ${getWhereClause()};`;
  };

  const fetchData = async () => {
    try {
      const [data, countResult, employees, masters] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
        fetchQuery("SELECT id, name FROM employees"),
        fetchQuery("SELECT id, Value FROM talentAcquisitionMaster WHERE type = 3")
      ]);

      const empList = employees || [];
      const masterList = masters || [];

      const mapped = (data || []).map((row) => ({
        ...row,
        recruiterAssigned: empList.find((e) => e.id == row.recruiterAssigned)?.name || row.recruiterAssigned || "",
        RequestStatus: masterList.find((m) => m.id == row.RequestStatus)?.Value || row.RequestStatus || "",
      }));

      setRequirementsList(mapped);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching requirements data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("Discipline");
    setSearchKey("");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched === false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-requirement"
          to="/talent-acquisition/editRequirements/0"
          label="Add Requirement"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Requirements"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />
      <ListView
        headers={headers}
        data={requirementsList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName="talentAcqRequirement"
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default RequirementsList;
